import { HttpContextToken } from '@angular/common/http';

/**
 * Opt a request out of the global 404 → not-found-page redirect performed by
 * errorInterceptor. Use it for sub-resource calls whose absence must not
 * navigate the user away from the page they are on (e.g. an empty collection
 * that the backend returns as 404). The caller then handles the 404 locally.
 */
export const SKIP_NOT_FOUND_REDIRECT = new HttpContextToken<boolean>(
  () => false
);
